
import { requests } from '.'

export const PaymentApi = {
  paymentAddOn: (productList: any, payMethod: number, imp_uid: string|null, userCouponId?: number) => requests.post<any>('v1/payment/add-on', {productList, payMethod, imp_uid, userCouponId}),
};